import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface BudgetListingInfo {
  budgetYear: string;
}

const initialState: BudgetListingInfo = {
  budgetYear: "",
};

const createBudgetListingSlice = createSlice({
  name: "budgetListing",
  initialState,
  reducers: {
    setCreateBudgetListing: (
      state,
      action: PayloadAction<Partial<BudgetListingInfo>>
    ) => {
      return { ...state, ...action.payload };
    },
    removeBudgetListing: () => initialState,
  },
});

export const { setCreateBudgetListing, removeBudgetListing } =
  createBudgetListingSlice.actions;
export default createBudgetListingSlice.reducer;
